import React from 'react';
import PropTypes from 'prop-types';

// Cover the BottomUpConnector with the background color
export function StopConnectorAtTheTop({ backgroundColor, height }) {
  return (
    <div style={{
      position: 'absolute',
      width: '100%',
      height,
      top: `-${height}px`,
      left: 0,
      backgroundColor,
      zIndex: 1,
    }}
    />
  );
}

StopConnectorAtTheTop.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
};
